// TODO 企业中心创新创业子平台
import apiConfig from "@/config/apiConfig";

const rootPath = apiConfig.commonApi;
const servicePath = apiConfig.innovationApi;

// const uploadApi = apiConfig.uploadApi;
//需求管理
export const demandApi = {
    saveOrUpdate: rootPath + "/basicsNeedInfo/saveOrUpdate", // 新增修改(put)
    detail: rootPath + "/basicsNeedInfo/detail", // 根据id查询详情(get)
    pageList: rootPath + "/basicsNeedInfo/pageList", // 分页查询(get)
    list: rootPath + "/basicsNeedInfo/list", // 无分页查询(get)
    remove: rootPath + "/basicsNeedInfo/remove/", // 删除/批量删除-根据ids(delete)
    sellerCancel: rootPath + "/basicsNeedInfo/sellerCancel/", // 取消需求
    affirm: rootPath + "/basicsNeedInfo/affirm/", // 确认需求
    abutmentList: rootPath + "/basicsNeedInfo/abutmentList/", // 需求对接的个人、企业、机构列表
    needList: rootPath + "/basicsNeedInfo/needList/", // 个人、企业、机构对接的需求列表
    audit: rootPath + "/basicsNeedInfo/audit/", // 需求审核
    drawNeed: rootPath + "/basicsNeedInfo/drawNeed/", // 领取、对接需求
    accomplish: rootPath + "/basicsNeedInfo/accomplish/", // 对接方==》完成需求对接
    purchaserCancel: rootPath + "/basicsNeedInfo/purchaserCancel/", // 对接方==》取消对接
    verify: rootPath + "/basicsNeedInfo/verify/", // 对接方==》申请平台方介入
};

//产业管理
export const industryApi = {
    saveOrUpdate: rootPath + "/innovationProductNeedInfo/saveOrUpdate", // 新增修改(put)
    detail: rootPath + "/innovationProductNeedInfo/detail", // 根据id查询详情(get)
    pageList: rootPath + "/innovationProductNeedInfo/pageList", // 分页查询(get)
    remove: rootPath + "/innovationProductNeedInfo/remove/", // 删除/批量删除-根据ids(delete)
};

//安全中心
export const vislogApi = {
    pageList: rootPath + "/systemLogApp/pageList",  //分页
}

//政策匹配
export const policyApi = {
    listRules: rootPath + "/enterpriseCompanyOriginInfo/listRules",  //分页
    listInfo: rootPath + "/policy/info/listInfo/",  //分页
    getDetail: rootPath + "/policy/info/getDetail",  //详情
}

//服务机构
export const organizationApi = {
    saveOrUpdate: rootPath + "/innovationMechanismInfo/saveOrUpdate",  //新增或者编辑数据
    pageList: rootPath + "/innovationMechanismInfo/pageList",  //新增或者编辑数据
    detail: rootPath + "/innovationMechanismInfo/detail",  //新增或者编辑数据
}

export const MechanismInfoApi = {
    saveOrUpdate: rootPath + "/innovationMechanismInfo/saveOrUpdate", // 新增修改(put)
    detail: rootPath + "/innovationMechanismInfo/detail", // 根据id查询详情(get)
    detailId: rootPath + "/innovationMechanismInfo/detailId", // 根据id查询详情(get)
    pageList: rootPath + "/innovationMechanismInfo/pageList", // 分页查询(get)
    list: rootPath + "/innovationMechanismInfo/list", // 无分页查询(get)
    remove: rootPath + "/innovationMechanismInfo/remove/", // 删除/批量删除-根据ids(delete)
    pageExamineList: rootPath + "/innovationMechanismInfo/pageExamineList", // 审核通过的分页查询
    examine: rootPath + "/innovationMechanismInfo/examine", // 审核
};

//活动报名
export const activityApi = {
    pageList: rootPath + "/basicsActivityApply/pageList",  //分页查询
}

//我的收藏
export const collectApi = {
    pageList: rootPath + "/basicsCollectInfo/pageList",  //分页查询
}

//创新自测
export const selftestApi = {
    detailScore: rootPath + "/enterpriseCompanyOriginInfo/detailScore",  //分页查询
}

//消息通知
export const notificationApi = {
    pageList: rootPath + "/basicsNoticeAnnounceUser/detailUserId",  //分页查询
    detail: rootPath + "/basicsNoticeAnnounceUser/read",  //详情
}
//科研机构
export const ScientificApi = {
    pageList: rootPath + "/innovationOrganizationInfo/pageList", //分页
    detail: rootPath + "/innovationOrganizationInfo/detail", // 详情
    remove: rootPath + "/innovationOrganizationInfo/remove/", // 删除
    saveOrUpdate: rootPath + "/innovationOrganizationInfo/saveOrUpdate", // 新增编辑

};

//基地管理
export const baseApi = {
    saveOrUpdate: rootPath + "/innovationBaseInfo/saveOrUpdate", // 新增修改(put)
    detail: rootPath + "/innovationBaseInfo/detail", // 根据id查询详情(get)
    pageList: rootPath + "/innovationBaseInfo/pageList", // 分页查询(get)
    historyList: rootPath + "/innovationBaseInfo/historyList", // 分页查询(get)
    list: rootPath + "/innovationBaseInfo/list", // 无分页查询(get)
    remove: rootPath + "/innovationBaseInfo/remove/", // 删除/批量删除-根据ids(delete)
};
//基地企业联查
export const companyBaseApi = {
    saveOrUpdate: rootPath + "/innovationBaseCompany/saveOrUpdate", // 新增修改(put)
};


// TODO 门户页面接口
//活动
export const activity = {
    pageList: servicePath + "/web/basicsActivityInfo/pageList", // 分页
    detail: servicePath + "/web/basicsActivityInfo/detail", // 详情
    save: servicePath + "/manage/basicsActivityApply/saveOrUpdate",  // 点击报名按钮
};

//基地
export const base = {
    gather: servicePath + "/web/innovationBaseInfo/gather", // 基地汇总
    pageList: servicePath + "/web/innovationBaseInfo/pageList", // 分页
    detail: servicePath + "/web/innovationBaseInfo/detail", // 详情
};

//通知公告
export const noticeWeb = {
    pageList: servicePath + "/web/innovationPolicyLibrary/pageList", // 分页
    detail: servicePath + "/web/innovationPolicyLibrary/detail", // 详情
};

//政策公告
export const policyWeb = {
    pageList: servicePath + "/web/pageList", // 分页
    getDetail: servicePath + "/web/getDetail", // 详情

};

//联系我们
export const basicsContactInfo = {
    pageList: servicePath + "/web/basicsContactInfo/pageList", // 分页
    detail: servicePath + "/web/basicsContactInfo/detail", // 详情

};


//访问量
export const volumeWeb = {
    saveVisits: servicePath + "/web/basicsVisitsInfo/saveVisits", // 新增访问量
};
//收藏
export const collectWeb = {
    saveOrUpdate: servicePath + "/web/basicsCollectInfo/saveOrUpdate", // 收藏
    romver: servicePath + "/web/basicsCollectInfo/cancel", // 取消收藏
    Iscancel: servicePath + "/web/basicsCollectInfo/collect", // 受否收藏
};

//双创数据
export const ganizationWeb = {
    analysis: servicePath + "/portal/companyPointsSystem/getCompanyData", // 获取企业数据
    baseCharts: servicePath + "/web/innovationBaseInfo/charts", //基地汇总
    propertyCharts: servicePath + "/web/knowledgePropertyTransaction/analyse", //知识产权分析
};


//调查问卷接口
export const sheetWeb = {
    pageList: servicePath + "/web/innovationTemplate/sheet", // 调查问卷
};

